import { useUpdateSetCompanyInternalConfig } from "./useUpdateSetCompanyInternalConfig";
import { useSuccessToast } from "@/hooks/useSuccessToast";
import { UpdateCompanyInternalConfigRequest } from "@/types";

export const useCompanyInternalConfigSubmit = (
  companyInternalConfigId: string,
  successMessage: string,
) => {
  const { mutate, isPending } = useUpdateSetCompanyInternalConfig();
  const successToast = useSuccessToast();

  const handleSubmit = (data: UpdateCompanyInternalConfigRequest) => {
    mutate(
      { id: companyInternalConfigId, updateRequest: data },
      {
        onSuccess: () => {
          successToast({ description: successMessage });
        },
      },
    );
  };

  return { handleSubmit, isPending };
};
